module.exports = __webpack_public_path__ + "img/2026-06-09 Cliniclowns Kadlez.323a62b3.jpg";